var map = {
	"./20.svg": "bc6f",
	"./21-40.svg": "818d",
	"./41-60.svg": "2391",
	"./61-80.svg": "0cd0",
	"./80.svg": "8a44",
	"./help.svg": "2b26"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34f9";